import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputLabel, TextField } from "@material-ui/core";
import { Check, Close } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { getClickButton } from "../../../../functions/getButtons";
import WithLoadingSpinners from "../../../hoc/WithLoadingSpinner";

const StyledWarningInputLabel = styled(InputLabel)`
  color: red;
  margin-top: 5px;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;

interface IConfirmSecretDialogProps {
  showDialog: boolean;
  setShowDialog: (val: boolean) => void;
  processUpdate: () => void;
}

export const ConfirmSecretDialog = (props: IConfirmSecretDialogProps) => {
  const { showDialog, setShowDialog, processUpdate } = props;

  const [confirmText, setConfirmText] = React.useState<string>("");
  const [confirmError, setConfirmError] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const validateConfirmation = async () => {
    setConfirmError(false);
    if (!confirmText || confirmText.toLowerCase() !== "yes") {
      setConfirmError(true);
      return;
    }
    setIsLoading(true);
    await processUpdate();
    setIsLoading(false);
    setShowDialog(false);
  };

  const closeDialog = () => {
    setConfirmError(false);
    setConfirmText("");
    setShowDialog(false);
  };

  const updateConfirmText = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmError(false);
    setConfirmText(evt.target.value);
  };

  return (
    <WithLoadingSpinners message="Setting Secret" isLoading={isLoading}>
      <Dialog open={showDialog} maxWidth="md" onClose={closeDialog} area-labelledby="qmlativ-update-secret-dialog-title">
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Taking this action will replace your secret for this environment. Any active integrations will stop working until you update the secret in your
            application with the new secret.
          </DialogContentText>
          <InputLabel>Type 'Yes' to Confirm</InputLabel>
          <StyledTextField onChange={updateConfirmText}>{confirmText}</StyledTextField>
          {confirmError && (
            <DialogContentText>
              <StyledWarningInputLabel>Confirmation text did not match 'Yes', please confirm 'Yes' to proceed</StyledWarningInputLabel>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          {getClickButton("Cancel", <Close />, () => closeDialog(), "secondary")}
          {getClickButton("Confirm", <Check />, () => validateConfirmation())}
        </DialogActions>
      </Dialog>
    </WithLoadingSpinners>
  );
};

export default ConfirmSecretDialog;
